(function(angular, jwtDecode){
    'use strict';

    class TranslationBootstrapService {
        constructor($http, $window, $q, translationService){
            this.$http = $http;
            this.$window = $window;
            this.$q = $q;
            this.translationService = translationService;
        }

        getCookie(cname) {
                let name = cname + '=';
                let decodedCookie = decodeURIComponent(document.cookie);
                let ca = decodedCookie.split(';');
                for(let i = 0; i <ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) === ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) === 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return '';
            }

        parseJwt(token) {
            var decodedToken;

            if (token) {
                try {
                    decodedToken = jwtDecode(token);
                } catch(error) {
                    //Do nothing, we'll bail out later
                }
            }

            return decodedToken;
        }

        getBrowserLocale() {
            let userLang = navigator.language;

            if (userLang === 'zh') {
                return 'zh_CN';
            }

            return userLang;
        }

        getJwtLocale() {
            var jwt = this.getCookie('gydaToken');
            var decodedJwt = this.parseJwt(jwt);
            var jwtLocale;

            if(decodedJwt && decodedJwt.user) {
                jwtLocale = decodedJwt.user.language;
            }

            return jwtLocale;
        }

        getUserTranslationData(ICM_ASSETS_URL) {
            let translationConfig = this.$q.defer();
            let jwtLocale = this.getJwtLocale();
            let translationPath = ICM_ASSETS_URL + 'translations/';
            let translationConfigObj = {
                $locale: 'en',
                $translationList: {}
            };

            if (jwtLocale) {
                translationConfigObj.$locale = jwtLocale;
            } else if (this.getBrowserLocale()) {
                translationConfigObj.$locale = this.getBrowserLocale().split('-')[0];
            }

            if (translationConfigObj.$locale === 'us') {
                translationConfigObj.$locale = 'en';
            }

            translationPath += translationConfigObj.$locale + '.json';
            this.$http.get(translationPath).then((res)=>{
                translationConfigObj.$translationList = res.data;
                translationConfig.resolve(translationConfigObj);
            });

            return translationConfig.promise;
        }
    }

    angular.module('MW.Influencers.TranslationBootstrapService', ['MW.Framework.TranslationService'])
    .service('TranslationBootstrapService', [
        '$http',
        '$window',
        '$q',
        'translationService',
        TranslationBootstrapService
    ]);

})(window.angular, window.jwt_decode); // jshint ignore:line
